export const origin = (): string => globalThis.location?.origin;
